import React from "react";
import Button from "@mui/material/Button";

const CustomButton = ({
  children,
  className = "",
  variant = "contained", // 'contained' | 'outlined' | 'text'
  onClick,
  style,
  type = "button"
}) => {
  const isOutlined = variant === "outlined";

  return (
    <Button
      variant={variant}
      type={type}
      onClick={onClick}
      className={className}
      sx={{
        borderRadius: "100px",
        fontSize: "14px",
        fontFamily: "inherit",
        cursor: "pointer",
        height: "56px",
        padding: "16px 32px",
        width: isOutlined ? "auto" : "auto",
        alignSelf: "stretch",
        marginTop: "auto",
        marginBottom: "auto",
        textTransform:'capitalize',
        gap: "10px",
        backgroundColor: isOutlined ? "#ffffff" : "#182cd4",
        color: isOutlined ? "#182cd4" : "#ffffff",
        border: isOutlined ? "1px solid #182cd4" : "none",
        "&:hover": {
          backgroundColor: isOutlined ? "#f0f0f0" : "#1a2de0"
        }
      }}
      style={style}
    >
      {children}
    </Button>
  );
};

export default CustomButton;